import { useEffect, useState } from "react";
import { useWebSocket } from "react-use-websocket/dist/lib/use-websocket";
import { io } from "socket.io-client";

const intervalMapping = {
  "1min": 60,
  "5min": 5 * 60,
  "15min": 15 * 60,
  "30min": 30 * 60,
  "1hour": 60 * 60,
  "2hour": 2 * 60 * 60,
  "4hour": 4 * 60 * 60,
  "6hour": 6 * 60 * 60,
  "12hour": 12 * 60 * 60,
  "1day": 24 * 60 * 60,
  "3day": 3 * 24 * 60 * 60,
  "1week": 7 * 24 * 60 * 60,
};

function getIntervalBySeconds(seconds) {
  for (const [key, value] of Object.entries(intervalMapping)) {
    if (value === seconds) {
      return key;
    }
  }
  return "1min";
}

const socketType = process.env.REACT_APP_SOCKET_TYPE;

const socket = io(process.env.REACT_APP_IRAN_SOCKET_URL, { transports: ["websocket"] });

const useKlines = (cryptoPair, timeInterval, page = 1) => {
  const [liveResult, setLiveResult] = useState({});

  const [websocketInfo, setWebsocketInfo] = useState({
    repeats: 0,
    success: 0,
  });

  const [shouldUseWebSocket, setShouldUseWebSocket] = useState(true);
  const { sendJsonMessage, lastJsonMessage, readyState } = useWebSocket(
    socketType !== "iran" ? process.env.REACT_APP_GERMANY_SOCKET_URL : null,
    {
      onOpen: (e) => {},
      onMessage: (e) => {},
      shouldReconnect: (closeEvent) => {
        return true;
      },
      pingTimeout: 1000,
      share: true,
      pingMessage:
        socketType === "iran"
          ? undefined
          : JSON.stringify({
              method: "server.ping",
              params: [],
              id: 11,
            }),
    }
  );

  const handleDisconnect = () => {
    socket.connect();
  };

  useEffect(() => {
    if (socketType === "iran") {
      socket.on("connect", () => {
        console.log("Socket connected!");
      });

      socket.on("kline", (data) => {
        setLiveResult(data);
        setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
      });

      socket.on("disconnect", handleDisconnect);

      return () => {
        socket.off("connect");
        socket.off("kline");
        socket.off("disconnect");
      };
    }
  }, [socketType, cryptoPair, timeInterval, page]);

  useEffect(() => {
    let interval = null;

    if (socketType === "iran") {
      interval = setInterval(() => {
        if (socket.connected) {
          // const date = new Date();
          // const now = date.getTime();
          // const startTime =
          //   Math.floor((now / 1000 - page * 500 * +timeInterval) / +timeInterval) *
          //   +timeInterval;
          // const endTime =
          //   Math.floor((now / 1000 - (page - 1) * 500 * +timeInterval) / +timeInterval) *
          //   +timeInterval;

          const now = Date.now();
          const nowSeconds = Math.floor(now / 1000);
          const startTime = nowSeconds - page * 500 * timeInterval;
          const endTime = nowSeconds - (page - 1) * 500 * timeInterval;

          socket.emit(
            "kline",
            JSON.stringify({
              type: "kline",
              market_pair: cryptoPair.toUpperCase(),
              interval: getIntervalBySeconds(timeInterval),
              count: 10,
              startTime,
              endTime,
              timeInterval,
            })
          );

          socket.emit(
            "state",
            JSON.stringify({
              type: "state",
              market_pair: cryptoPair.toUpperCase(),
            })
          );
        }
      }, 1000);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [socketType, cryptoPair, timeInterval, page]);

  // useEffect(() => {
  //   let interval = null;

  //   if (socketType === "iran") {
  //     interval = setInterval(() => {
  //       const date = new Date();
  //       const now = date.getTime();
  //       const startTime =
  //         Math.floor((now / 1000 - page * 500 * +timeInterval) / +timeInterval) *
  //         +timeInterval;
  //       const endTime =
  //         Math.floor((now / 1000 - (page - 1) * 500 * +timeInterval) / +timeInterval) *
  //         +timeInterval;

  //       socket.on("connect", () => {
  //         if (socket.connected) {
  //           socket.emit(
  //             "kline",
  //             JSON.stringify({
  //               type: "kline",
  //               market_pair: cryptoPair.toUpperCase(),
  //               interval: getIntervalBySeconds(timeInterval),
  //               count: 10,
  //               startTime,
  //               endTime,
  //               timeInterval,
  //             })
  //           );
  //         }
  //       });
  //       socket.on("kline", (data) => {
  //         setLiveResult(data);
  //         setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
  //       });
  //       socket.on("disconnect", handleDisconnect);

  //       return () => {
  //         socket.off("connect");
  //         socket.off("kline");
  //       };
  //     }, 1000);

  //     return () => clearInterval(interval);
  //   }
  // }, [cryptoPair, readyState, timeInterval, page]);

  useEffect(() => {
    let interval = null;

    if (socketType !== "iran") {
      if (readyState === 1) {
        interval = setInterval(() => {
          const date = new Date();
          const now = date.getTime();
          const startTime =
            Math.floor((now / 1000 - page * 500 * +timeInterval) / +timeInterval) *
            +timeInterval;
          const endTime =
            Math.floor((now / 1000 - (page - 1) * 500 * +timeInterval) / +timeInterval) *
            +timeInterval;
          setWebsocketInfo((prev) => ({ ...prev, repeats: prev.repeats + 1 }));
          sendJsonMessage({
            method: "kline.query",
            params: [cryptoPair.toUpperCase(), startTime, endTime, +timeInterval],
            id: 5,
          });
        }, 1000);
      } else if (readyState === 3) {
        setShouldUseWebSocket(false);
      }
      return () => socketType !== "iran" && clearInterval(interval);
    }
  }, [readyState, timeInterval, page]);

  //اگه سوکت اوکی باشه دیتا رو دریافت میکنه
  useEffect(() => {
    if (lastJsonMessage !== null && socketType !== "iran") {
      if (lastJsonMessage.id === 5) {
        // console.log(lastJsonMessage);
        setWebsocketInfo((prev) => ({ ...prev, success: prev.success + 1 }));
        const { result } = lastJsonMessage;
        setLiveResult(result);
      }
    }
  }, [lastJsonMessage]);

  // بررسی شرایط کانکت بودن انجام میده
  useEffect(() => {
    const { repeats, success } = websocketInfo;
    const errorRate = (repeats - success) / repeats;
    if (repeats > 20 && errorRate > 0.3 && shouldUseWebSocket === true) {
      setShouldUseWebSocket(false);
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
    const successRate = success / repeats;
    if (repeats > 20 && successRate >= 0.7 && shouldUseWebSocket === false) {
      setShouldUseWebSocket(true);
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
    if (repeats > 30) {
      setWebsocketInfo({
        repeats: 0,
        success: 0,
      });
    }
  }, [websocketInfo]);

  return { liveResult, shouldUseWebSocket };
};
export default useKlines;
